import { jsx as o } from "@emotion/react/jsx-runtime";
import { memo as e } from "react";
import { Text as i } from "@partoohub/ui";
const t = e(({
  description: r
}) => /* @__PURE__ */ o(i, { variant: "bodyLRegular", as: "span", color: "secondary", children: r }));
t.displayName = "Description";
export {
  t as Description
};
